import { connect } from "react-redux";
import {
  xoaHopDong,
  showXoaHopDong,
  kiemTraXoaHopDong,
} from "actions/XoaHopDong";
import { getListCamDo } from "actions/CamDo";
import XoaHopDong from "components/CommonComponent/Xoa";

const mapStateToProps = (state) => ({
  xoahopdong: state.xoahopdong,
  camdo: state.camdo,
});

const mapDispatchToProps = (dispatch) => ({
  xoaHopDong: (dataPost, callback) => dispatch(xoaHopDong(dataPost, callback)),
  showXoaHopDong: () => dispatch(showXoaHopDong()),
  kiemTraXoaHopDong: (dataPost) => dispatch(kiemTraXoaHopDong(dataPost)),
  getListCamDo: (dataSearch) => dispatch(getListCamDo(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(XoaHopDong);
